import { render, staticRenderFns } from "./projectClass.vue?vue&type=template&id=947f68e4&scoped=true"
import script from "./projectClass.vue?vue&type=script&lang=js"
export * from "./projectClass.vue?vue&type=script&lang=js"
import style0 from "./projectClass.vue?vue&type=style&index=0&id=947f68e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "947f68e4",
  null
  
)

export default component.exports